module.exports = __webpack_public_path__ + "static/media/sf-trial-1-wrong.a2c9fa68.mp3";